import { h, render } from 'preact';
import App from './App';
import './index.css';

render(
  <App />,
  document.getElementById('root')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/